<template xmlns="http://www.w3.org/1999/html">
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> Invoice payments
                    </div>
                    <div class="card-block filters">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-3">
                                    <select v-model="filter.clientFilter" class="form-control form-control-sm">
                                        <option :value="null">All clients</option>
                                        <option v-for="client in clients" :value="client.id">{{client.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <span role="group" class="btn-group">
                                        <button @click="filter.showDanger = !filter.showDanger" :class="filter.showDanger ? 'btn-danger' : 'btn-outline-danger'" class="btn btn-sm">Overdue</button>
                                        <button @click="filter.showWarning = !filter.showWarning" :class="filter.showWarning ? 'btn-warning' : 'btn-outline-warning'" class="btn btn-sm">Unpaid</button>
                                        <button @click="filter.showSuccess = !filter.showSuccess" :class="filter.showSuccess ? 'btn-success' : 'btn-outline-success'" class="btn btn-sm">Paid</button>
                                        <button @click="clearFilters()" class="btn btn-sm btn-secondary">Clear filters</button>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-1">
                                <div class="col-md-3">
                                    <datepicker input-class="invoices-date-picker" v-model="filter.filterFrom" :disabled-dates="{from: new Date(filter.filterTo)}" format="yyyy-MM-dd"></datepicker>
                                </div>
                                <div class="col-md-3">
                                    <datepicker input-class="invoices-date-picker" v-model="filter.filterTo" :disabled="!filter.filterFrom" :disabled-dates="{to: new Date(filter.filterFrom)}" format="yyyy-MM-dd"></datepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-block">
                        <div class="col-md-12 table-view">
                            <table class="table table-bordered table-condensed">
                                <thead>
                                    <th class="table-head-th invoice-width">Invoice</th>
                                    <th class="table-head-th">Project</th>
                                    <th class="table-head-th">Payment</th>
                                    <th class="table-head-th">Revenue</th>
                                    <th class="table-head-th">Prepayment</th>
                                    <th class="table-head-th">To be paid</th>
                                    <th class="table-head-th">To be paid w/ VAT</th>
                                    <th class="table-head-th">Paid sum</th>
                                    <th class="table-head-th text-center">Date</th>
                                    <th class="table-head-th text-center">Due Date</th>
                                    <th class="table-head-th text-center">Payment Date</th>
                                    <th class="table-head-th">Actions</th>
                                </thead>
                                <tbody>
                                    <tr v-for="invoice in invoicesByDueDate"
                                        :class="invoiceStyle(invoice)" 
                                        v-if="showInvoices(invoice)"
                                    >
                                        <td @click="editInvoice(invoice.invoice_id)" class="action invoice-width">{{invoice.contract.contract_name}}</td>
                                        <td><span @click="$router.push({ name: 'ProjectTabInvoicesPayments', params: { id: invoice.project_id }})" class="action">{{invoice.project ? invoice.project.name : ''}}</span></td>
                                        <td><span v-if="invoice.payment" :title="invoice.payment.description">[{{invoice.payment_id}}] {{invoice.payment.expected_on}} for {{(invoice.payment.amount/100).toFixed(2)}}€</span></td>
                                        <td class="text-right text-monospace">{{(invoice.revenue/100).toFixed(2)}}</td>
                                        <td class="text-right text-monospace">{{(invoice.prepayment/100).toFixed(2)}}</td>
                                        <td class="text-right text-monospace">{{(invoice.sum/100).toFixed(2)}}</td>
                                        <td class="text-right text-monospace">{{(invoice.sum_with_vat/100).toFixed(2)}}</td>
                                        <td class="text-right text-monospace">{{(invoice.paid_sum/100).toFixed(2)}}</td>
                                        <td class="text-center text-nowrap">{{invoice.date}}</td>
                                        <td class="text-center text-nowrap">{{invoice.due_date}}</td>
                                        <td class="text-center text-nowrap">{{invoice.payment_date}}</td>
                                        <td>
                                            <i class="fa fa-money fa-lg action" aria-hidden="true" @click="openLogPaymentModal(invoice.invoice_id)" title="Log payment"></i>
                                        </td>
                                    </tr>
                                    <tr class="table-sum">
                                        <td colspan="3">
                                            Total
                                        </td>
                                        <td class="text-right text-monospace">{{(tableSumRevenue/100).toFixed(2)}}</td>
                                        <td class="text-right text-monospace">{{(tableSumPrepayment/100).toFixed(2)}}</td>
                                        <td class="text-right text-monospace">{{(tableSum/100).toFixed(2)}}</td>
                                        <td class="text-right text-monospace">{{(tableSumWVAT/100).toFixed(2)}}</td>
                                        <td class="text-right text-monospace">{{(tablePaidSum/100).toFixed(2)}}</td>
                                        <td colspan="4"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal :show="false" title="Modal title" v-model="logPaymentModal" @ok="logInvoicePayment" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
                <h4 class="modal-title">Log payment</h4>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Paid amount</label>
                <div class="input-group col-md-9" v-if="activeInvoiceId">
                    <span class="input-group-addon"><i class="fa fa-euro"></i></span>
                    <input type="number" step="0.01" id="input3-group1" name="input3-group1" class="form-control" placeholder="1000.00" v-model="paidAmount">
                    <span class="input-group-addon" >/ {{(invoices[activeInvoiceId].sum/100).toFixed(2)}}€</span>
                </div>
                <label class="col-md-3 form-control-label">Payment date</label>
                <div class="col-md-9" v-if="activeInvoiceId">
                    <datepicker input-class="payments-date-picker" v-model="paymentDate" format="yyyy-MM-dd"></datepicker>
                </div>
            </div>
        </modal>
    </div>
</template>
<style>
    td {
        border: 1px solid #cfd8dc;
    }
    .table-sum td {
        background-color: #eceff1;
    }
</style>

<script>

import { mapGetters, mapActions } from 'vuex';
import modal from 'vue-strap/src/Modal';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'Invoices',
  components: {
    modal,
    Datepicker
  },
  watch: {
    filter: {
      handler: function (val) {
        this.recalculateTableSum();
      },
      deep: true
    },
    invoices: {
      handler: function (val) {
        this.recalculateTableSum();
      },
      deep: true
    }
  },
  data() {
    return {
      logPaymentModal: false,
      activeInvoiceId: '',
      paidAmount: '',
      paymentDate: null,
      filter: {
        clientFilter: null,
        filterFrom: moment(new Date()).subtract(2, 'months').format('YYYY-MM-DD'),
        filterTo: moment(new Date()).add(2, 'months').format('YYYY-MM-DD'),
        showSuccess: true,
        showWarning: true,
        showDanger: true,
      },
      tableSum: 0,
      tableSumWVAT: 0,
      tablePaidSum: 0,
      tableSumRevenue: 0,
      tableSumPrepayment: 0
    };
  },
  props: {
    showFilters: true,
    projectId: null,
  },
  computed: {
    ...mapGetters('Clients', [
      'invoices', 'invoicesByDueDate', 'clients'
    ]),
  },
  methods: {
    ...mapActions('Clients', [
      'GET_INVOICES_LIST',
      'GET_CLIENTS_LIST',
      'LOG_INVOICE_PAYMENT',
    ]),
    openLogPaymentModal(invoiceId) {
      this.activeInvoiceId = invoiceId;
      this.paidAmount = (this.invoices[invoiceId].paid_sum / 100).toFixed(2);
      this.paymentDate = this.invoices[invoiceId].payment_date || moment().format('YYYY-MM-DD');
      this.logPaymentModal = true;
    },
    logInvoicePayment() {
      this.LOG_INVOICE_PAYMENT({ invoiceId: this.activeInvoiceId, amount: Math.round(this.paidAmount * 100), paymentDate: moment(this.paymentDate).format('YYYY-MM-DD') });
      this.logPaymentModal = false;
    },
    editInvoice(invoiceId) {
      this.$router.push({ name: 'EditContract', params: { id: invoiceId } });
    },
    invoiceStyle(invoice) {
      if (invoice.paid_sum) return 'invoice-success';
      if (!invoice.due_date || (!invoice.paid_sum && new Date(invoice.due_date) >= new Date())) return 'invoice-warning';
      return 'invoice-danger';
    },
    invoiceInPeriod(invoice) {
      return (!this.filter.filterFrom || new Date(invoice.date) >= new Date(this.filter.filterFrom))
                       && (!this.filter.filterTo || new Date(invoice.date) <= new Date(this.filter.filterTo));
    },
    invoiceStatusFilter(invoice) {
      const status = this.invoiceStyle(invoice);
      switch (status) {
        case 'invoice-success': 
          return this.filter.showSuccess;
          break;
        case 'invoice-warning':
          return this.filter.showWarning;
          break;
        case 'invoice-danger':
          return this.filter.showDanger;
          break;
        default:
          return false;
      }
    },
    clearFilters() {
      this.filter.filterTo = this.filter.filterFrom = this.filter.clientFilter = '';
      this.filter.showSuccess = this.filter.showWarning = this.filter.showDanger = true;
    },
    recalculateTableSum() {
      this.tableSum = 0;
      this.tableSumWVAT = 0;
      this.tablePaidSum = 0;
      this.tableSumPrepayment = 0;
      this.tableSumRevenue = 0;

      for (const i in this.invoicesByDueDate) {
        if (this.showInvoices(this.invoicesByDueDate[i])) {
          this.tableSum += this.invoicesByDueDate[i].sum;
          this.tableSumWVAT += this.invoicesByDueDate[i].sum_with_vat;
          this.tablePaidSum += this.invoicesByDueDate[i].paid_sum;
          this.tableSumRevenue += this.invoicesByDueDate[i].revenue;
          this.tableSumPrepayment += this.invoicesByDueDate[i].prepayment;
        }
      }
    },
    showInvoices(invoice) {
      let show = false;
      if (invoice.contract
                    && (!this.filter.clientFilter || this.filter.clientFilter == invoice.contract.client_id)
                    && this.invoiceInPeriod(invoice)
                    && this.invoiceStatusFilter(invoice)
                    && (!this.projectId || this.projectId == invoice.project_id)) {
        show = true;
      }
      return show;
    }
  },
  notifications: {
  },
  created() {
    this.GET_INVOICES_LIST();
    this.GET_CLIENTS_LIST();
  }
};
</script>
<style lang="scss" scoped>

    .action {
        margin-left: 5px;

        &:hover {
            cursor: pointer;
            color: #ee0044;
        }
    }
    .invoice-success{
        background-color: #e1ffe1;
    }
    .invoice-danger{
        background-color: #f0c8c8;
    }
    .invoice-success:hover {
        background-color: #c1ffc1;
    }
    .invoice-danger:hover{
        background-color: #f0a8a8;
    }
    .invoice-warning:hover{
        background-color: #efefef
    }
    th, td, .filters input[type="date"] {
        padding: 0.15rem;
        vertical-align: middle;
        font-size: 12px;
    }
    .table-head-th {
        /*min-width: 80px;*/
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        z-index: 1;
        background: white;
    }
    .table-view {
        overflow-y: scroll;
        position: relative;
        max-width: 1500px;
        max-height: 800px;
    }

    td.invoice-width {
        max-width: 300px;
    }
</style>
<style>
    .invoices-date-picker {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        height: 1.8125rem;
        color: #607d8b;
        padding: 0.5rem 0.75rem;

    }
    .payments-date-picker {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #607d8b;
        height: 35px;
        padding: 0.5rem 0.75rem;
    }
</style>
